import { Button, Form, GetProp, Input, message, Modal, Select } from "antd";
import form from "antd/es/form";
import Dragger from "antd/es/upload/Dragger";
import DashboardLayout from "layout/DashboardLayout";
import { useState } from "react";
import { TbLoader2, TbUpload } from "react-icons/tb";
import Papa from "papaparse";
import { RcFile, UploadChangeParam, UploadFile, UploadProps } from "antd/es/upload";
import DragAndDrop from "components/DragAndDrop/DragAndDrop";
import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import { ApiService } from "api/api.service";
import CaseMapping from "components/CaseMapping/CaseMapping";
import { UseQueryResult } from "@tanstack/react-query";
import { loader } from "components/QueryWrapper";

dayjs.extend(isSameOrBefore);

type FileType = Parameters<GetProp<UploadProps, "beforeUpload">>[0];
const DynamicUpload = ({
  dynamicModalOpen,
  setDynamicModalOpen,
  fetchLeadDetails,
}: {
  dynamicModalOpen: boolean;
  setDynamicModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  fetchLeadDetails: UseQueryResult;
}) => {
  // const [modal2Open, setModal2Open] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState<File | null>(null);
  const [fileHeader, setFileHeader] = useState<string[]>([]);
  const [isComplete, setIsComplete] = useState(false);
  const sendExcelFile = ApiService.lead.useGetFileHeaders();
  const [dymanicMappedData, setDynamicMappedData] = useState<Record<string, string>>({});
  const [previewData, setPreviewData] = useState<Record<string, string[]>>({});
  const postDynamicMapping = ApiService.lead.useUploadDynamicCase();
  const [form] = Form.useForm();
  // console.log(uploadedFiles);

  const handleFileChange = (info: UploadChangeParam<UploadFile>) => {
    const { fileList } = info; // Extract file list

    if (fileList.length > 0) {
      const file = fileList[fileList.length - 1]; // Get the last uploaded file
      const isExcelOrCSV =
        file.type === "text/csv" || file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      // if(file.size){
      //   const isLt10M = file.size / 1024 / 1024 < 10;
      // }
      if (!isExcelOrCSV) {
        message.error("You can only upload Excel/CSV file!");
        return;
      }

      // const isExcelFile = file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      if (file) {
        const formData = new FormData();
        formData.append("file", file.originFileObj as File);
        // console.log(file);
        setUploadedFiles(file.originFileObj as File);
        sendExcelFile.mutate(formData, {
          onSuccess: (res) => {
            message.success("File parsed successfully");
            setFileHeader(res.result.headers?.filter((el) => el?.length > 0));
            setPreviewData(res.result.previews);
            setIsComplete(true);
          },
          onError: () => {
            setIsComplete(false);
          },
          // onError: () => {
          //   message.error("Failed to parse file");
          // },
        });
      }

      // else if (file && !isExcelFile) {
      //   const originFIle = file.originFileObj;
      //   if (originFIle) {
      //     setUploadedFiles(originFIle);
      //     Papa.parse(originFIle, {
      //       header: true,
      //       skipEmptyLines: true,
      //       delimiter: "", // Auto-detects delimiter
      //       complete: (results) => {
      //         setFileHeader(Object.keys(results.data[0] as object));
      //         setIsComplete(true);
      //       },
      //     });
      //   } else {
      //     message.error("File could not be processed.");
      //   }
      // }
    }
  };

  const beforeUpload = (file: FileType) => {
    // console.log(file);
    const isExcelOrCSV =
      file.type === "text/csv" || file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const isExcel = file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

    if (!isExcelOrCSV) {
      message.error("You can only upload Excel/CSV file!");
    }
    const isLt10M = file.size / 1024 / 1024 < 10;
    if (!isLt10M) {
      message.error("File must smaller than 10MB!");
    }
    return isExcelOrCSV && isExcelOrCSV;
  };

  const handleOk = () => {
    if (dymanicMappedData["caseNumber"] === "") {
      message.error("Key number shouldn't be empty");
      return;
    }
    const formData = new FormData();
    formData.append("file", uploadedFiles as File);
    formData.append("mapping", JSON.stringify(dymanicMappedData));
    // console.log(dymanicMappedData);
    postDynamicMapping.mutate(
      { mappedData: formData },
      {
        onSuccess: () => {
          message.success("Cases uploaded successfully");
          setDynamicModalOpen(false);
          setIsComplete(false);
          fetchLeadDetails.refetch();
        },
      },
    );
    // console.log(dymanicMappedData);
  };
  return (
    <div>
      {/* <Button onClick={() => setModal2Open(true)}>Open</Button> */}

      <Modal
        title="Upload Files"
        // loading={sendExcelFile.isPending}
        centered
        width={800}
        // height={500}

        open={dynamicModalOpen}
        onOk={handleOk}
        okButtonProps={{
          disabled: postDynamicMapping.isPending,
          loading: postDynamicMapping.isPending,
          icon: postDynamicMapping.isPending && <TbLoader2 className="animate-spin" />,
        }}
        onCancel={() => {
          setIsComplete(false);
          setDynamicModalOpen(false);
          setUploadedFiles(null);
        }}
      >
        {/* File Upload Section */}

        {!isComplete && !sendExcelFile.isPending && (
          <Dragger
            accept=".xls,.csv,.xlsx"
            multiple={false}
            // fileList={uploadedFiles}
            showUploadList={false}
            onChange={handleFileChange}
            // beforeUpload={() => false} // Prevent automatic upload, handle it manually
            listType="text"
          >
            <div style={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
              <p className="ant-upload-drag-icon">
                <TbUpload size={28} />
              </p>
              <p className="ant-upload-text">Click or drag files to this area to upload</p>
              <p className="ant-upload-hint">Supports single or bulk upload.</p>
            </div>
          </Dragger>
        )}
        {!isComplete && sendExcelFile.isPending && loader}
        {isComplete && (
          <CaseMapping fileHeader={fileHeader} previewData={previewData} setDynamicMappedData={setDynamicMappedData} />
        )}

        {/* <input type="file" onChange={handleFileChange} /> */}
      </Modal>
    </div>
  );
};

export default DynamicUpload;
